module.exports = __webpack_public_path__ + "static/gamma-911f03a32b77c522d7867eb71ddd45f3.jpg";